import PropTypes from "prop-types"
import { factorFormatter } from "helpers/formatters/numbers"
import { COMPOSITE } from "../shapes"

function formatTicker({ ticker, country, assetClass }) {
  if (assetClass === "index" || (country === "US" && assetClass === "etf")) {
    return `${ticker}`
  }

  return `${ticker}.${country}`
}

export default function Composite({ account, modelId, composite, openCompositeSecurity }) {
  const { assetClass, description, factorExposure } = composite

  function onClick(event) {
    event.preventDefault()

    const type = assetClass === "index" ? assetClass : "etf"
    openCompositeSecurity(account, { ...composite, type }, true, modelId)
  }

  return <li onClick={onClick} className={assetClass}>
    <div className="ticker">{formatTicker(composite)}</div>
    <div className="name">{description}</div>
    <div className="correlation">{factorFormatter(factorExposure)}</div>
  </li>
}

Composite.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  composite: COMPOSITE.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
}
